module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-1.d5bf043e.png";